import { Routes } from '@angular/router'
import { StateListComponent } from './components/state-list/stateList.component'

export const routes: Routes = [
    {
        path: 'stateList/:toolUrl', component: StateListComponent
    }
]